/**
 * Single FAQ entry
 */

//  Deps
import { createComponent } from "react-fela";
import { fancyList } from "~/styleguide/fancy-list";
import { colors } from "~/styleguide";

export default function Feature({ feature }) {
    const { title, description } = feature;

    return (
        <Container extend={fancyList}>
            {title && <Name dangerouslySetInnerHTML={{ __html: title }} />}
            {description && <Description dangerouslySetInnerHTML={{ __html: description }} />}
            <Indicator></Indicator>
        </Container>
    );
}

const Container = createComponent(() => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidthMobile: {
        flexWrap: "wrap"
    }
}));

const Name = createComponent(() => ({
    width: "15%",
    fontWeight: "bold",
    fontSize: 18,
    maxWidthMobile: {
        width: "calc(100% - 50px)",
        marginBottom: 10
    }
}), "div", ["dangerouslySetInnerHTML"]);

const Description = createComponent(() => ({
    width: "75%",
    fontSize: 18,
    maxWidthMobile: {
        width: "calc(100% - 50px)"
    }
}), "div", ["dangerouslySetInnerHTML"]);

const check =
    "data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.64579 12.0285L6.17127 16.554L16.3536 6.37167' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A";

const Indicator = createComponent(() => ({
    width: 32,
    height: 32,
    backgroundImage: 'url("' + check + '")',
    backgroundPosition: "center 7px",
    backgroundSize: "15px auto",
    backgroundRepeat: "no-repeat",
    backgroundColor: colors.blue,
    borderRadius: "50%",
    maxWidthMobile: {
        position: "absolute",
        right: 25,
        top: 0,
        bottom: 0,
        margin: "auto"
    }
}));
